export const SPECIAL_ASSIGNMENTS_CONFIG = {
  officeName: {
    label: 'Office Name',
    allowClear: true,
    placeholder: 'Enter text',
  },
  officeNumber: {
    label: 'Office Number',
    allowClear: true,
    placeholder: 'Enter text',
  },
  odName: {
    label: 'OD Name',
    allowClear: true,
    placeholder: 'Enter text',
  },
  eeid: {
    label: 'EEID',
    allowClear: true,
    placeholder: 'Enter text',
  },
  description: {
    label: 'Description',
    allowClear: true,
    placeholder: 'Enter text',
  },
  dateRange: {
    label: 'Date Range Start and End',
    allowClear: true,
    type: 'daterange',
  },
};
